/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkspaceMembersBatchDeleteResponseItem,
    WorkspaceMembersBatchDeleteResponseItemFromJSON,
    WorkspaceMembersBatchDeleteResponseItemFromJSONTyped,
    WorkspaceMembersBatchDeleteResponseItemToJSON,
} from './WorkspaceMembersBatchDeleteResponseItem';

/**
 * 
 * @export
 * @interface WorkspaceMembersBatchDeleteResponse
 */
export interface WorkspaceMembersBatchDeleteResponse {
    /**
     * 
     * @type {Array<WorkspaceMembersBatchDeleteResponseItem>}
     * @memberof WorkspaceMembersBatchDeleteResponse
     */
    results?: Array<WorkspaceMembersBatchDeleteResponseItem>;
}

export function WorkspaceMembersBatchDeleteResponseFromJSON(json: any): WorkspaceMembersBatchDeleteResponse {
    return WorkspaceMembersBatchDeleteResponseFromJSONTyped(json, false);
}

export function WorkspaceMembersBatchDeleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersBatchDeleteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(WorkspaceMembersBatchDeleteResponseItemFromJSON)),
    };
}

export function WorkspaceMembersBatchDeleteResponseToJSON(value?: WorkspaceMembersBatchDeleteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(WorkspaceMembersBatchDeleteResponseItemToJSON)),
    };
}

